import debounce from 'lodash.debounce'
import React, { useCallback, useState } from 'react'
import { HiX } from 'react-icons/hi'
import {
  TColorPickerDataListWithCategories,
  TColor,
} from '../unifiedColorPicker.types'

type TListWithCategoriesColorPickerProps = {
  colorsList: TColorPickerDataListWithCategories
  showSearchBox?: boolean
  onChange?: (color: TColor) => void
  activeColor: TColor
}

export const ListWithCategoriesColorPicker = ({
  colorsList,
  showSearchBox,
  onChange,
  activeColor,
}: TListWithCategoriesColorPickerProps) => {
  const [categoriesWithColors, setCategoriesWithColors] = useState(
    colorsList || []
  )
  const [searchColor, setSearchColor] = useState('')

  const handleClick = (color: TColor) => {
    if (typeof onChange === 'function') {
      onChange(color)
    }
  }

  const doSearchColor = (colorText: string) => {
    const filteredCategoriesWithColors = categoriesWithColors
      .map(({ category, colors }) => {
        const filterdColors = colors.filter(
          (color) =>
            color.label.toLowerCase().includes(colorText) ||
            color.value.toLowerCase().includes(colorText)
        )
        return filterdColors.length > 0
          ? { category, colors: filterdColors }
          : null
      })
      .filter(Boolean)
    setCategoriesWithColors(filteredCategoriesWithColors)
  }

  const handleSearchColor = useCallback(debounce(doSearchColor, 300), [])

  const handleSearchChange = (e) => {
    const colorText = e.target.value
    setSearchColor(colorText)
    handleSearchColor(colorText.toLowerCase())
  }

  return (
    <div className="w-full">
      {showSearchBox && (
        <div className="relative">
          <input
            className="w-full leading-[16px] text-[16px] px-6 py-4 outline-0 mb-2 border bg-white border-black-10 rounded-[6px] focus:border-pitaya-40"
            placeholder="🔍 Search"
            value={searchColor}
            onChange={handleSearchChange}
            autoCorrect="false"
            autoCapitalize="false"
            spellCheck="false"
          />
          {searchColor && (
            <HiX
              className="absolute right-0 top-[30%] w-[16px] h-[16px] mr-4 cursor-pointer"
              onClick={() => {
                setSearchColor('')
                setCategoriesWithColors(colorsList)
              }}
            />
          )}
        </div>
      )}
      <div className="flex flex-col max-h-[200px] overflow-scroll scroll-smooth no-scrollbar">
        {categoriesWithColors.length > 0 ? (
          <dl className="w-full">
            {categoriesWithColors.map(({ category, colors }) => {
              return (
                <React.Fragment key={category}>
                  <dt className="sticky top-0 bg-white z-2 leading-[20px] text-xl font-semibold text-acai p-[10px] border-b border-black-20">
                    {category}
                  </dt>
                  {colors.map((color) => (
                    <div
                      key={color.label}
                      onClick={() => handleClick(color)}
                      className={`flex items-center gap-[12px] p-[10px] text-lg ${
                        activeColor?.label === color.label ? 'bg-black-10' : ''
                      } hover:bg-black-10 border-b border-black-20`}
                    >
                      <span
                        className="inline-block w-[30px] h-[30px] rounded-full border border-black-10 scale-100 duration-300"
                        style={{ backgroundColor: color.value }}
                      ></span>
                      <span>{color.label}</span>
                    </div>
                  ))}
                </React.Fragment>
              )
            })}
          </dl>
        ) : (
          <span className="inline-block w-full text-center p-[4px] text-xl text-pitaya-80">
            Not found
          </span>
        )}
      </div>
    </div>
  )
}
